import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { CmdbSearchFilterService } from 'src/app/page_component/cmdb-search-filter/service/cmdb-search-filter.service';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { presetInterface } from 'src/app/util/interfaces/preset';
import { environment } from 'src/environments/environment';
import { reportColumnInterface } from '../interface/reportColumnInterface';

@Injectable({
	providedIn: 'root',
})
export class ReportFormService {
	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	private getRequestFormOptionsUrl = environment.baseApiUrl + 'report/paramsAccordionFor?grabItems=false&getCustomfields=true';
	private getRequestFormItemsUrl = environment.baseApiUrl + 'report/params/item';
	private getCmdbFormOptionsUrl = environment.baseApiUrl + 'reportcmdb/report/params/{reportSubtype}';
	private getStockFormOptionsUrl = environment.baseApiUrl + 'stock/report/params/{reportSubtype}';
	private getRequestTaskFormOptionsUrl = environment.baseApiUrl + 'request/report/params/{reportSubtype}';
	private getMysupportEvaluationFormOptionsUrl = environment.baseApiUrl + 'mysupportEvaluation/report/params/{reportSubtype}';
	private getCustomSatisfactionFormOptionsUrl = environment.baseApiUrl + 'customSatisfaction/report/params/{reportSubtype}';
	private getTaskAndCustomFieldsFormOptionsUrl = environment.baseApiUrl + 'reportrequest/report/params/{reportSubtype}';
	private getLogsFieldsFormOptionsUrl = environment.baseApiUrl + 'reportrequest/report/params/{reportSubtype}';
	private postReportUrl = environment.baseApiUrl + 'report';
	private getReportParamsUrl = environment.baseApiUrl + 'report/{idReport}/params';
	private putReportParamsUrl = environment.baseApiUrl + 'report/{idReport}';
	private getPresetsByType = environment.baseApiUrl + 'register/searchPreset';
	private getAvailableReportColumnUrl = environment.baseApiUrl + 'report/column';
	private getTableColumnsUrl = environment.baseApiUrl + 'mspTable/column';

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient,
		private CmdbSearchFilterService: CmdbSearchFilterService
	) {}

	getForm(formType: 'request' | 'cmdb' | 'stock' | 'evaluate', reportSubType: string): Observable<genericFormI[]> {
		if (
			(formType === 'request' && reportSubType === 'task') ||
			(formType === 'request' && reportSubType === 'satisfaction') ||
			(formType === 'request' && reportSubType === 'satisfactionCustom') ||
			(formType === 'request' && reportSubType === 'taskAndCustomFields')
		) {
			let getAllFormOptionsUrl = '';
			reportSubType === 'task' || reportSubType === 'satisfaction'
				? (getAllFormOptionsUrl = this.getRequestTaskFormOptionsUrl.replace('{reportSubtype}', reportSubType))
				: '';
			reportSubType === 'satisfactionCustom'
				? (getAllFormOptionsUrl = this.getCustomSatisfactionFormOptionsUrl.replace('{reportSubtype}', reportSubType))
				: '';
			reportSubType === 'taskAndCustomFields'
				? (getAllFormOptionsUrl = this.getTaskAndCustomFieldsFormOptionsUrl.replace('{reportSubtype}', reportSubType))
				: '';
			return this.http.get<JSON[]>(getAllFormOptionsUrl, { headers: this.headers }).pipe(
				map((formOptionsRes) => {
					const newFormOptionsArray: genericFormI[] = [];
					formOptionsRes.forEach((formOption: any) => {
						const newFormOption: genericFormI = {
							id: formOption.name_param,
							inputType: formOption.type_param,
							name: formOption.name_param,
							label: formOption.label_param,
							items: [],
							values: [],
							rawValues: [],
							commonGroup: '',
							outItems: [],
							filterItem: [],
							filterValues: [],
						};

						if (formOption.items && formOption.items.length > 0) {
							formOption.items.forEach((item: any) => {
								const newItem: genericFormI['items'][number] = {
									label: item.label_item,
									name: item.name_item,
									values: [item.value_item],
								};

								newFormOption.items.push(newItem);
							});
						}
						newFormOptionsArray.push(newFormOption);
					});
					return newFormOptionsArray;
				})
			);
		}

		if (formType === 'request' || reportSubType === 'logs') {
			return this.http.get<JSON[]>(this.getRequestFormOptionsUrl, { headers: this.headers }).pipe(
				map((formOptionsRes) => {
					const newFormOptionsArray: genericFormI[] = [];
					formOptionsRes.forEach((formOption: any) => {
						const newFormOption: genericFormI = {
							id: formOption.id,
							inputType: formOption.inputType,
							name: formOption.name,
							label: formOption.label,
							items: formOption.items,
							values: formOption.values,
							rawValues: formOption.rawValues,
							commonGroup: formOption.commonGroup,
							outItems: [],
							filterItem: [],
							filterValues: [],
						};

						newFormOptionsArray.push(newFormOption);
					});

					return newFormOptionsArray;
				})
			);
		}

		if ((formType === 'cmdb' && reportSubType != 'general') || (formType === 'cmdb' && reportSubType === 'general')) {
			const getCmdbFormOptionsUrl = this.getCmdbFormOptionsUrl.replace('{reportSubtype}', reportSubType);
			return this.http.get<JSON[]>(getCmdbFormOptionsUrl, { headers: this.headers }).pipe(
				map((formOptionsRes) => {
					const newFormOptionsArray: genericFormI[] = [];
					formOptionsRes.forEach((formOption: any) => {
						const newFormOption: genericFormI = {
							id: formOption.name_param,
							inputType: formOption.type_param,
							name: formOption.name_param,
							label: formOption.label_param,
							items: [],
							values: [],
							rawValues: [],
							outItems: [],
							filterItem: [],
							filterValues: [],
							// "selected": formOption.selected_param,
						};

						if (formOption.items && formOption.items.length > 0) {
							formOption.items.forEach((item: any) => {
								const newItem: genericFormI['items'][number] = {
									label: item.label_item,
									name: item.name_item,
									values: [item.value_item],
								};
								newFormOption.items.push(newItem);
							});
						}
						newFormOptionsArray.push(newFormOption);
					});

					return newFormOptionsArray;
				})
			);
		}

		if (formType === 'stock') {
			const getStockFormOptionsUrl = this.getStockFormOptionsUrl.replace('{reportSubtype}', reportSubType);
			return this.http.get<JSON[]>(getStockFormOptionsUrl, { headers: this.headers }).pipe(
				map((formOptionsRes) => {
					const newFormOptionsArray: genericFormI[] = [];
					formOptionsRes.forEach((formOption: any) => {
						const newFormOption: genericFormI = {
							id: formOption.name_param,
							inputType: formOption.type_param,
							name: formOption.name_param,
							label: formOption.label_param,
							items: [],
							values: [],
							rawValues: [],
						};
						if (formOption.items && formOption.items.length > 0) {
							formOption.items.forEach((item: any) => {
								const newItem: genericFormI['items'][number] = {
									label: item.label_item,
									name: item.name_item,
									values: [item.value_item],
								};
								newFormOption.items.push(newItem);
							});
						}
						newFormOptionsArray.push(newFormOption);
					});
					return newFormOptionsArray;
				})
			);
		}

		if (formType === 'evaluate') {
			const getMysupportEvaluationFormOptionsUrl = this.getMysupportEvaluationFormOptionsUrl.replace(
				'{reportSubtype}',
				reportSubType
			);
			return this.http.get<JSON[]>(getMysupportEvaluationFormOptionsUrl, { headers: this.headers }).pipe(
				map((formOptionsRes) => {
					const newFormOptionsArray: genericFormI[] = [];
					formOptionsRes.forEach((formOption: any) => {
						const newFormOption: genericFormI = {
							id: formOption.name_param,
							inputType: formOption.type_param,
							name: formOption.name_param,
							label: formOption.label_param,
							items: [],
							values: [],
							rawValues: [],
						};
						if (formOption.items && formOption.items.length > 0) {
							formOption.items.forEach((item: any) => {
								const newItem: genericFormI['items'][number] = {
									label: item.label_item,
									name: item.name_item,
									values: [item.value_item],
								};
								newFormOption.items.push(newItem);
							});
						}
						newFormOptionsArray.push(newFormOption);
					});
					return newFormOptionsArray;
				})
			);
		}

		return of([]);
	}

	getFormItem(formItemName: string): any {
		const getRequestFormItemsUrl = this.getRequestFormItemsUrl + '?paramName=' + formItemName;
		return this.http.get<JSON>(getRequestFormItemsUrl, { headers: this.headers });
	}

	createReport(
		reportName: string,
		reportParameters: genericFormI[],
		reportType: 'request' | 'cmdb' | 'stock' | 'evaluate',
		reportSubtype: string,
		columns: reportColumnInterface[]
	): Observable<any> {
		const body = {
			report_name: reportName,
			report_type: reportType,
			report_sub_type: reportSubtype,
			columns: columns,
			params: [],
		};

		for (const reportForm of reportParameters) {
			const newParameter = {
				id_param: reportForm.id,
				param_value: [],
			};

			for (const [index, value] of reportForm.values.entries()) {
				if (reportForm.inputType === 'multi-select') newParameter.param_value.push(reportForm.rawValues[index]);
				else newParameter.param_value.push(value);
			}

			body.params.push(newParameter);
		}
		return this.http.post<JSON>(this.postReportUrl, body, { headers: this.headers });
	}

	updateReport(
		idReport: string,
		reportName: string,
		reportParameters: genericFormI[],
		columns: reportColumnInterface[]
	): Observable<JSON> {
		const body = {
			report_name: reportName,
			params: [],
			columns: columns,
		};

		for (const reportForm of reportParameters) {
			const newParameter = {
				id_param: reportForm.id,
				param_value: [],
			};
			for (const [index, value] of reportForm.values.entries()) {
				if (reportForm.inputType === 'multi-select') newParameter.param_value.push(reportForm.rawValues[index]);
				else newParameter.param_value.push(value.toString());
			}

			body.params.push(newParameter);
		}
		const updateReportUrl = this.putReportParamsUrl.replace('{idReport}', idReport);
		return this.http.put<JSON>(updateReportUrl, body, { headers: this.headers });
	}

	getReportParams(idReport: string): Observable<any> {
		const reportParameterUrl = this.getReportParamsUrl.replace('{idReport}', idReport);

		return this.http.get<JSON>(reportParameterUrl, { headers: this.headers }).pipe(
			map((reportParameter: any) => {
				reportParameter.dictionary = {};
				for (const parameter of reportParameter.params) {
					reportParameter.dictionary[parameter.id_param] = parameter.param_value;
				}

				return reportParameter;
			})
		);
	}

	getPresetByType(type: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		const getLocalityByIdURL = this.getPresetsByType + '?typePreset=' + type;

		return this.http.get<presetInterface[]>(getLocalityByIdURL, {
			headers: headers,
		});
	}

	getReportAvailableColumns(type: string, subtype: string): Observable<reportColumnInterface[]> {
		return this.http
			.get<any>(this.getAvailableReportColumnUrl, { headers: this.headers, params: { type: type, subtype: subtype } })
			.pipe(
				map((columnRes) => {
					const returnData: reportColumnInterface[] = [];

					for (const key of Object.keys(columnRes)) {
						const returnItem: reportColumnInterface = {
							id: columnRes[key].id,
							label: columnRes[key].label,
							name: columnRes[key].name,
							colType: '',
						};

						if (key.startsWith('customfield_')) returnItem.name = columnRes[key].name;

						returnData.push(returnItem);
					}

					return returnData;
				})
			);
	}

	getInitialSelectedColumns(type: string, subtype: string): Observable<string[]> {
		if (type !== 'request' || subtype !== 'general') {
			return of([]);
		}

		const requiredColumns = ['id', 'summary', 'status', 'open_date'];
		const fallbackColumns = ['limit_date', 'enduser', 'solution_area'];

		return this.http.get<string[]>(this.getTableColumnsUrl, { headers: this.headers, params: { source: 'request' } }).pipe(
			map((selectedColumns) => {
				const persistedColumns = Array.isArray(selectedColumns) ? selectedColumns : [];
				const columns =
					persistedColumns.length === 0 ? [...requiredColumns, ...fallbackColumns] : requiredColumns.concat(persistedColumns);

				return columns.filter((column, index) => columns.indexOf(column) === index);
			}),
			catchError(() => of([...requiredColumns, ...fallbackColumns]))
		);
	}
}
